import PaginationButtons from './PaginationButtons';
import Pagination from './Pagination';

export default Pagination;
export { PaginationButtons };
